<app-menu headerCSS="bg-dark"></app-menu>
<div class="header-inner bg-light text-center">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h2 class="text-primary">Reset Password</h2>
        <ol class="breadcrumb mb-0 p-0">
          <li class="breadcrumb-item"><a href="index.html"> Home </a></li>
          <li class="breadcrumb-item active">
            <i class="fas fa-chevron-right"></i> <span> Reset Password </span>
          </li>
        </ol>
      </div>
    </div>
  </div>
</div>

<section class="space-ptb">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-xl-8 col-lg-10 col-md-12">
        <div class="login-register">
          <div class="section-title">
            <h4 class="text-center">Reset Password</h4>
          </div>
          <div class="form-row">
            <div class="form-group col-12">
              <label for="Email2">Email Address</label>
              <input id="email" type="email" class="form-control" name="email" placeholder="Email Address"
                #txtResetEmail="ngModel" [class.is-invalid]="txtResetEmail.invalid && txtResetEmail.touched" required
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" [(ngModel)]="resetEmail" />
              <div *ngIf="txtResetEmail.errors && (txtResetEmail.invalid && txtResetEmail.touched)">
                <small class="text-danger" *ngIf="txtResetEmail.errors.required">Email is required</small>
                <small class="text-danger" *ngIf="txtResetEmail.errors.pattern">Please provide a valid email
                  address</small>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6">
              <button type="submit" class="btn btn-primary btn-block"
                (click)="handleResetPasswordBtnClick(txtResetEmail)">
                Send Password Reset Link
              </button>
            </div>
            <div class="col-md-6">
              <div class="ml-md-3 mt-3 mt-md-0 forgot-pass">
                <p class="mt-1">
                  New User?
                  <a [routerLink]="['/signup']">Register Here</a>
                </p>
                <p class="mt-1">
                  Have Account?
                  <a [routerLink]="['/signin']">Sign in Here</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="mt-5 bottom">
<app-footer></app-footer>
</section>